import { ErrorLoggerSdk } from '@sxm-de/dev-kits/web-sdk/types';

export function logErrorFromClientSdk(
    error: { message: string; code: string; stack: string },
    dependencies: { errorLoggerSdk: ErrorLoggerSdk },
): void {
    const { errorLoggerSdk } = dependencies;
    /**
     * Note:
     * We are executing the logError call without waiting for it to resolve so this happens
     * as a side-effect and not blocking.
     */
    errorLoggerSdk.logError({
        message: `[${error.code}]: ${error.message}`,
        stacktrace: error.stack,
    });
}
